import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { Col, Container, Image, Row, Nav, Button } from "react-bootstrap"
import { FaList, FaThLarge } from 'react-icons/fa';

import S from '../lib/Security';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import C from '../lib/Confg'
import MasterConfiguration from './MasterConfiguration';
import N from '../lib/Network';

var Buffer = require('buffer/').Buffer
var CryptoJS = require("crypto-js");

const NexadminDashboard = () => {
    useEffect(() => {
        getKeys(); 
        localStorage.getItem('tenantId');
    }, [])
    function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
      }
    return (
        <div id="content-wrapper" className="d-flex flex-column">
            {<Sidebar />}
            {<Topbar />}
            <div id="wrapper">
                <div id="content">
                    {/* <!-- Begin Page Content --> */}
                    <Container fluid>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <div className="card dash-data-card">
                                    <div className="card-header pl-4 pr-4">
                                        <h5 className="headerTitle float-left mt-1">NexAdmin</h5>
                                        <div className="ml-auto float-right">
                                            {/* <Link to="/DashboardVerticalView"  className="btn btn-sm btn-primary shadow-sm">
                                                <FaList className="fas"/>
                                            </Link > */}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                        
                            { (localStorage.getItem("isP2PRole")) ?
                            <Col xs={6} md={4} lg={4} className="mt-3">
                                <Link to="/NexAdminConfiguration" id="" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img//web-management.png')} style={{width: '70px'}} />
                                                    </div>
                                                </div>
                                                <div className="mt-auto mb-auto" style={{width: '60%'}}>
                                                    <h5 className="big font-weight-bold text-secondary pt-2"> P2P</h5>
                                                    <div className="project-label text-muted"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                            : null }

                            { (localStorage.getItem("isRentANDUtilityRole")) ?
                            <Col xs={6} md={4} lg={4} className="mt-3">
                                <Link to="/NexAdminConfigurationRent" id="" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img//web-management.png')} style={{width: '70px'}} />
                                                    </div>
                                                </div>
                                                <div className="mt-auto mb-auto" style={{width: '60%'}}>
                                                    <h5 className="big font-weight-bold text-secondary pt-2"> Rent</h5>
                                                    <div className="project-label text-muted"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                            : null }
                        </Row>
                    </Container>
                    {/* <!-- /.container-fluid --> */}
                </div>
            </div>
        </div>
    )
}
export default NexadminDashboard;